/* eslint-disable jsx-a11y/media-has-caption */

import React, { useState } from "react";

import { Icon } from "@culturehq/components";

import { getImageFromStory } from "app/utils";
import imagesSizes from "constants/imagesSizes";
import Subtitles from "components/common/Subtitles";

const EmptyPreview = ({ story }) => {
  const mediaRef = React.createRef();
  const [showVideoInfo, setShowVideoInfo] = useState(false);

  const handlePlay = () => {
    mediaRef.current.play();
  };

  const imageUrl = story.media.mediaType === "image" ? getImageFromStory(imagesSizes.NORMAL, story) : story.media.thumbnail;

  return (
    <div className="SocialMedia-Preview Preview-Empty">
      <div className="Body_Header Preview-User">
        <div className="Preview-User__Info-Container">
          <div className="Preview-User__Photo" />
          <div className="Preview-User__Title">
            <p className="Preview-Name" />
            <p />
          </div>
        </div>
        <div className="SocialIcon" />
      </div>
      <div className="Details-Container">
        <p className="Full-Width" />
        <p />
      </div>
      <div className="gallery-lightbox__photo">
        <div className="gallery-lightbox__image-container" style={{ backgroundImage: `url(${imageUrl})` }} />
        {story.media.mediaType === "image" && (
          <img
            className="gallery-lightbox__photo--image"
            ref={mediaRef}
            src={imageUrl}
            alt={story.imageAlt || story.question.question}
          />
        )}
        {story.media.mediaType === "video" && (
          <>
            {showVideoInfo && (
              <div className="gallery-lightbox__video-play" onClick={handlePlay}><Icon icon="play-filled" /></div>
            )}
            <video
              controls
              className="gallery-lightbox__main-image gallery-lightbox__main-video"
              onPause={() => setShowVideoInfo(true)}
              onPlay={() => setShowVideoInfo(false)}
              poster={`${story.media.thumbnail}?not-from-cache-please`}
              ref={mediaRef}
              src={story.media.url}
              disablePictureInPicture
              crossOrigin="anonymous"
              controlsList="nodownload"
            >
              <Subtitles media={story.media} />
            </video>
          </>
        )}
      </div>
      <div className="PreviewActions" />
    </div>
  );
};

export default EmptyPreview;
